<script setup>
import CampaignCard from 'dashboard/components-next/Campaigns/CampaignCard/CampaignCard.vue';

defineProps({
  campaigns: {
    type: Array,
    required: true,
  },
  isLiveChatType: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits([
  'edit',
  'delete',
  'start',
  'pause',
  'resume',
  'cancel',
  'preview',
  'progress',
]);

const handleEdit = campaign => emit('edit', campaign);
const handleDelete = campaign => emit('delete', campaign);
</script>

<template>
  <div class="flex flex-col gap-4">
    <CampaignCard
      v-for="campaign in campaigns"
      :key="campaign.id"
      :title="campaign.title"
      :audience-description="campaign.audience_description || ''"
      :message="campaign.message"
      :is-enabled="campaign.enabled"
      :status="campaign.campaign_status"
      :sender="campaign.sender"
      :inbox="campaign.inbox"
      :scheduled-at="campaign.scheduled_at"
      :is-live-chat-type="isLiveChatType"
      :is-drip="campaign.is_drip"
      :drip-status="campaign.drip_status"
      :drip-config="campaign.drip_config"
      @edit="handleEdit(campaign)"
      @delete="handleDelete(campaign)"
      @start="emit('start', campaign)"
      @pause="emit('pause', campaign)"
      @resume="emit('resume', campaign)"
      @cancel="emit('cancel', campaign)"
      @preview="emit('preview', campaign)"
      @progress="emit('progress', campaign)"
    />
  </div>
</template>
